import React from 'react';
import usePlatform from '../../hooks/usePlatform';
import IconAiArrow from '../../components/IconWrapper/arrow-ai';
import './index.scss';

const cardList = [
  {
    logo: '/images/aip-1.png',
    title: 'AI管理驾驶舱',
    name: 'aivault',
    desc: '企业管理的辅助决策中枢，将管理理论和经验注入软件，让企业能够⾃主思考、决策、⾏动，帮助企业实现从战略到执行的自主智能运行'
  },
  {
    logo: '/images/aip-2.png',
    title: '业务应用',
    name: 'application',
    desc: '将应用模块集成在统一平台上，灵活组合满足企业多种业务需求。解决从运营管理、采销流通到生态协同全链路经营问题，实现全链协同的智慧应用',
    // href: 'https://www.terminus.io/product-category/2002'
  },
  {
    logo: '/images/aip-3.png',
    title: 'AI智能平台',
    name: 'aifoundation',
    desc: '企业级AI构建平台，支持AI应用的全生命周期管理，从构建、评测、观测到优化，让企业轻松实现智能自治'
  },
  {
    logo: '/images/aip-4.png',
    title: 'Trantor软件构建平台',
    name: 'trantor',
    desc: '企业级软件开发平台，通过可视化配置和无代码或少量代码，帮助企业快速构建复杂业务系统，提升开发效率，降低技术门槛'
  },
  {
    logo: '/images/aip-5.png',
    title: 'Erda企业数字化平台',
    name: 'erda',
    desc: '一站式开源云原生PaaS，把 DevOps、微服务治理、多云管理与快数据装进同一平台，让企业一键提速交付、弹性运维、盘活数据，低成本落地云原生数字化',
    href: 'https://www.erda.cloud',
  }
];

const AIP: React.FC = () => {
  const { isPc } = usePlatform() || {};

  return (
    <div id="aip" className="aip-section">
      {/* 顶部背景区域 */}
      <div className="aip-header">
        <video
          className="aip-header-video"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="https://terminus-emp.oss-cn-hangzhou.aliyuncs.com/aip/aip-bg6.mp4" type="video/mp4" />
        </video>
        <div className="aip-header-content">
          <h1 className="aip-title">AIP</h1>
          <h2 className="aip-subtitle">企业智慧管理平台</h2>
          <div className="aip-desc">
            <p>以 AI 的认知、推理与决策能力，构建了从底层平台到业务应用的全面驱动企业运营的企业AI管理框架</p>
            <p>拥有层级清晰、贯通战略到执行、具备自我学习与演进能力的 AI 管理顾问团队（AI Agent）</p>
            <p>覆盖战略决策、生产计划、供应链、财务等关键环节，解决从运营管理、采销流通到生态协同全链路经营难题</p>
            <p>帮助企业实现从“战略意图”到“业务落地”的全链路智能闭环</p>
          </div>
        </div>
      </div>

      {/* 产品卡片区域 */}
      <div className="aip-cards">
        {cardList.map((card, index) => (
          <a target="_blank" href={card.href || `/aip/${card.name}`} key={index} className="aip-card">
            <img className="aip-card-icon" src={card.logo} alt={card.title} />
            <div className="aip-card-content">
              <h3 className="aip-card-title">{card.title}</h3>
              <p className="aip-card-desc">{card.desc}</p>
            </div>
            {isPc && (
              <div className="aip-card-arrow">
                <IconAiArrow size={20}/>
              </div>
            )}
          </a>
        ))}
      </div>
    </div>
  );
};

export default AIP;
